import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import TireTreadManufacturer from './tire-tread-manufacturer';
import TireTreadManufacturerDetail from './tire-tread-manufacturer-detail';
import TireTreadManufacturerUpdate from './tire-tread-manufacturer-update';
import TireTreadManufacturerDeleteDialog from './tire-tread-manufacturer-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TireTreadManufacturerUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TireTreadManufacturerUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={TireTreadManufacturerDetail} />
      <ErrorBoundaryRoute path={match.url} component={TireTreadManufacturer} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TireTreadManufacturerDeleteDialog} />
  </>
);

export default Routes;
